import React, { useContext, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import GloblePopup from "../common/GloblePopup";
import { GlobalContext } from "../global/GlobalProvider";
import config from "../config";
import OtpInput from "./OtpInput";
import { set } from "lodash";

export default function OTPVerifyPopup() {
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [loding, setLoading] = useState(false);
  const [isAlertShow, setAlertShow] = useState(false);
  const [alertType, setAlertType] = useState('');
  const [alertMessage, setAlertMessage] = useState('');
  let second = 65;
  const {
    setTelegramPop,
    telegamPopupOpen,
    isLoggedIn,
  } = useContext(GlobalContext);
  const [timer, setTimer] = useState(second); // Timer in seconds

  useEffect(() => {
    let timer;
    if (isAlertShow) {
      timer = setTimeout(() => {
        setAlertShow(false);
        setAlertType('');
        setAlertMessage('');
      }, 3000);
    }
    return () => clearTimeout(timer);
  }, [isAlertShow]);


  useEffect(() => {
    if (telegamPopupOpen) {
      setTimer(second); // Reset timer when popup opens
      resetOtp(); // Reset OTP input
    }
    return () => {};
  }, [telegamPopupOpen]);

  const handleOtpChange = (newOtp) => {
    console.log("Current OTP:", newOtp);
    if (newOtp.length === 6) {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${config.userData.token}`);

      const raw = JSON.stringify({ code: newOtp });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(`${process.env.REACT_APP_BASE_URL}/api/v1/auth/varifytelecode`, requestOptions)
        .then(async (response) => {
          let paresData = await response.json();
          if (response.ok) {
            setLoading(false);
            setTelegramPop(false);
            localStorage.setItem("bannerOpen", false);
            sessionStorage.setItem("token", config.userData.token);
            sessionStorage.setItem("sessionId", config.userData.sessionId);
            sessionStorage.setItem(
              "userinfo",
              JSON.stringify(config.userData.user)
            );
            sessionStorage.setItem(
              "issecureauthenable",
              config.userData.user?.issecureauthenable
                ? config.userData.user?.issecureauthenable
                : false
            );
            sessionStorage.setItem("userId", config.userData.user._id);
            sessionStorage.setItem("loggedIn", "true");
            isLoggedIn();
            window.location.replace("/sport");
            setAlertShow(true);
            setAlertType('success');
            setAlertMessage("Login Successful!");
            isLoggedIn();
          } else {
            setAlertShow(true);
            setAlertType('error');
            setAlertMessage(paresData.message);
            // setTelegramPop(false);
          }
        })
        .catch((error) => {
          setLoading(false);
            setAlertShow(true);
            setAlertType('error');
            setAlertMessage("An error occurred while verifying the OTP.");

        //   setTelegramPop(false);
          console.error("Error:", error);
        });
    }
  };

  const resetOtp = () => {
    setOtp(new Array(6).fill(""));
    handleOtpChange(""); // Optional: to clear parent's OTP string
    const firstInput = document.getElementById("otp-input-0");
    if (firstInput) firstInput.focus();
  };

  useEffect(() => {
    let interval;

    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
    //   setTelegramPop(false); // Close the popup when timer reaches zero
    //   setTimer(second); // Reset timer when popup opens
    //   setOtp(""); // Reset OTP when popup opens
    //   config.userData = {};
    //   resetOtp(); // Reset OTP input
    }

    return () => {
      clearInterval(interval);
    };
  }, [timer]);

const formatTime = (seconds) => {
  const displaySeconds = Math.max(seconds - 5, 0); // start from 60, show down to 0
  const m = String(Math.floor(displaySeconds / 60)).padStart(2, "0");
  const s = String(displaySeconds % 60).padStart(2, "0");
  return `${m}:${s}`;
};


  return ReactDOM.createPortal(
    <GloblePopup
      isOpen={telegamPopupOpen}
      onClose={() => setTelegramPop(false)}
      className="telegram-otp-popup"
    >
      <div class="otp-box">
        <div class="otp-box-wraper">
          <div class="otp-logo">
            <img src={localStorage.getItem("logo")} loading="lazy" alt="" />
          </div>
          <p class="verification-text">
            Security Code Verification Using Telegram App
          </p>
          <div class="otp-code">
            <p>Enter 6-digit code from your telegram bot Resend Code</p>
            <OtpInput otp={otp} setOtp={setOtp} onOtpChange={handleOtpChange} />
            {timer > 0 ? (
              <p class="timer-text">
                You must wait <strong>{formatTime(timer)}</strong> before
                attempting to log in again.
              </p>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      <div className={`alert ${alertType == 'error'? 'error' :''}  ${isAlertShow ? 'open' : ''}`}>{alertType == 'error'? <i className="fa fa-times-circle"/> :<i className="fas fa-check-circle"/>}  {alertMessage} </div>
      <div className={`inner-loader ${loding ? "show" : ""}`}></div>
    </GloblePopup>,
    document.body
  );
}
